import React from 'react';
import moment from 'moment';
import u from '../utilities/Utilities';
import store from 'store';
import {HOTOItem} from './HandTakeOverList';
import "../styles/task-report.scss";
import "../styles/hoto-report.scss";

export default class TakeoverReport extends React.Component{

    state={
        contentArray:[],
    }

    componentDidMount=()=>{
        const content = store.get("takeover-report");
        const moddedContent=content.map(
            (item)=>{
                item.totalDefects = item.hoInventory.map(
                    (inventory)=>{
                        return (inventory.defects.length);
                    }
                ).reduce((partialSum, a) => partialSum + a, 0);
                item.photoRender=this.imageArrayBreak(item.toPhotos);
                return item;
            }
        )
        this.setState({
            contentArray:moddedContent,
        });
    }

    setDef=(value,type)=>{
        if(!value){
            return "None";
        }
        else if(type == "datetime"){
            return moment(value).format("DD MMM YYYY - h:mma");
        }
        else if(type == "date"){
            return moment(value).format("DD MMM YYYY");
        }
        else if(type == "time"){
            return moment("2000-01-01T" + value).format("h:mma");
        }
        else if(type == "dow"){
            const labels = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
            let dow = "";
            for(var i=0; i<value.length; i++){
                if(value[i]){
                    dow = dow + ((dow.length > 0) ? " / " : "") + labels[i];
                }
            }
            return dow;
        }

        return value;
    };

    imageArrayBreak=(array)=>{
        if(!array){
            return [];
        }
        const isEven = (array.length % 2 == 0);
        let twoArray = [];
        let row = [];
        for(var i=0; i<array.length; i++){
            row.push(array[i]);
            if(i%2 == 1){
                //new object
                twoArray.push(row);
                row = [];
            }
        }
        if(!isEven){
            row.push[{}];
            twoArray.push(row);
        }
        return twoArray;
    }

    getTotalDamages=(content)=>{
        const toDamageList = HOTOItem.getDamageList(content);
        let damages = 0.0;
        for(var i=0; i<toDamageList.length; i++){
            const d = toDamageList[i];
            damages += HOTOItem.calculateDamages(d);
        }
        return "$"+damages.toFixed(2);
    }

    render=()=>{
        const contentArray=this.state.contentArray;
        return(
            <div>
              {
                contentArray.map(
                    (content,c)=>{
                        const toDamageList=HOTOItem.getDamageList(content);
                        return (
                          <div className="task-report-container" key={c}>
                              <img className="report-header-image" src="/images/app/app-logo.png"/>
                              <div className="report-title">Takeover Report</div>

                              <div className="report-section">
                                  <div className="report-section-title">Takeover Details</div>
                                  <div className="report-table">
                                      <table>
                                          <tbody>
                                              <tr className="report-row-double">
                                                <td><b>Dormitory</b></td>
                                                <td>{this.setDef(content.dormName)}</td>
                                                <td><b>Entry ID</b></td>
                                                <td>{this.setDef(content.hotoID)}</td>
                                              </tr>

                                              <tr className="report-row-double">
                                                <td><b>Prepared By</b></td>
                                                <td>{this.setDef(content.hoStaffName)}</td>
                                                <td><b>Prepared On</b></td>
                                                <td>{this.setDef(content.handoverOn,"datetime")}</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>

                              <div className="report-section">
                                  <div className="report-section-title">Estate Details</div>
                                  <div className="report-table">
                                      <table>
                                          <tbody>
                                              <tr>
                                                  <td className="report-item"><b>Client</b></td>
                                                  <td className="report-item">{this.setDef(content.clientName)}</td>
                                              </tr>
                                              <tr>
                                                  <td className="report-item"><b>Agreement</b></td>
                                                  <td className="report-item">{this.setDef(content.agreementReference)}</td>
                                              </tr>
                                              <tr>
                                                  <td className="report-item"><b>Location</b></td>
                                                  <td className="report-item">({content.estateType}) {this.setDef(content.estateLabel)}</td>
                                              </tr>
                                              <tr>
                                                  <td className="report-item"><b>Number of Beds</b></td>
                                                  <td className="report-item">{this.setDef(content.bedCount)}</td>
                                              </tr>
                                              <tr>
                                                  <td className="report-item"><b>Duration</b></td>
                                                  <td className="report-item">{moment(content.handoverOn).format("DD MMM YYYY")} - {moment(content.takeoverOn).format("DD MMM YYYY")}</td>
                                              </tr>
                                              <tr>
                                                  <td className="report-item"><b>Remarks</b></td>
                                                  <td className="report-item">{this.setDef(content.remarks)}</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>

                              <div className="report-section">
                                  <div className="report-section-title">Room/Bed Inventory</div>
                                  <div className="report-table">
                                      <table>
                                          <thead>
                                              <tr>
                                                  <th className='ho-sn'>Item</th>
                                                  <th className="ho-item"/>
                                                  <th className="ho-quantity">H/O</th>
                                                  <th className="ho-quantity">T/O</th>
                                                  <th className="ho-damages">Damages</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              {
                                                  content.toInventory.map(
                                                      (item,index)=>{
                                                          return (
                                                            <tr key={index}>
                                                                <td className="ho-sn">{index+1}.</td>
                                                                <td className="ho-item">{item.itemName}</td>
                                                                <td className="ho-quantity">{item.hoQuantity}</td>
                                                                <td className="ho-quantity">{item.toQuantity}</td>
                                                                <td className="ho-damages">{HOTOItem.getDamageAmount(item,content)}</td>
                                                            </tr>
                                                          )
                                                      }
                                                  )
                                              }
                                              <tr>
                                                  <td className="ho-sn" style={{border:"none",borderLeft:"1px solid #f4f4f4",borderBottom:"1px solid #f4f4f4"}}/>
                                                  <td className="ho-item" style={{border:"none",borderBottom:"1px solid #f4f4f4"}}/>
                                                  <td className="ho-quantity" style={{border:"none",borderBottom:"1px solid #f4f4f4"}}>Total:</td>
                                                  <td className="ho-quantity" style={{border:"none",borderBottom:"1px solid #f4f4f4"}}/>
                                                  <td className="ho-damages">{this.getTotalDamages(content)}</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>

                              {
                                  (content.totalDefects > 0)
                                      ?
                                      <div className="report-section">
                                          <div className="report-section-title">Handover Defects</div>
                                          <div className="report-section-desc">
                                              Defects shown below were identified during the handover process, client will not be liable for defects recorded in this section
                                          </div>
                                          <div className="report-table defect">
                                              <table>
                                                  <tbody style={{borderBottom:"2px solid #f4f4f4"}}>
                                                      {
                                                          content.hoInventory.map(
                                                              (item,index)=>{
                                                                  const numDefects=item.defects.map((defect)=>{
                                                                      return defect.defectQuantity;
                                                                  }).reduce((a,b)=>{return a+b}, 0);

                                                                  const numRectify=item.defects.map((defect)=>{
                                                                      return defect.resolveQuantity;
                                                                  }).reduce((a,b)=>{return a+b}, 0);

                                                                  if(numDefects == 0){
                                                                      return null;
                                                                  }
                                                                  return (
                                                                    <tr key={index}>
                                                                        <tr>
                                                                            <td style={{width:"100%",borderBottom:"none",paddingBottom:"0"}}>
                                                                                <span style={{marginRight:"5px"}}><b>{index+1}.</b></span>
                                                                                <span><b>{item.itemName}</b></span>
                                                                                <ul className="defect-ul">
                                                                                    {
                                                                                        item.defects.map(
                                                                                            (defect,d)=>{
                                                                                                return (
                                                                                                    <li key={d} className="defect-li">
                                                                                                        <span className={"defect-quantity" + ((defect.resolveQuantity > 0) ? " resolved" : "")}>{defect.defectQuantity}</span>
                                                                                                        {
                                                                                                            (defect.resolveQuantity > 0)
                                                                                                                ?
                                                                                                                <span className="resolve-quantity">{(parseInt(defect.defectQuantity) - parseInt(defect.resolveQuantity))}</span>
                                                                                                                :
                                                                                                                null
                                                                                                        }
                                                                                                        <span> x {defect.label}</span>
                                                                                                    </li>
                                                                                                )
                                                                                            }
                                                                                        )
                                                                                    }
                                                                                </ul>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{borderTop:"none",borderBottom:"none",padding:"0 10px",textAlign:"center"}}>
                                                                                <td className="to-defect-photo" style={{border:"none",paddingLeft:"0",borderRight:"1px solid #f4f4f4"}}>
                                                                                    <div style={{margin:"5px auto"}}><u>Defects</u></div>
                                                                                    <div style={{textAlign:(numDefects > 3) ? "left" : "center"}}>
                                                                                        {
                                                                                            item.defects.map(
                                                                                                (defect,d)=>{
                                                                                                    return defect.defectPhoto.map(
                                                                                                        (photo,p)=>{
                                                                                                            return (
                                                                                                                <img src={photo} key={d+"-"+p} className="defect-photo"/>
                                                                                                            )
                                                                                                        }
                                                                                                    )
                                                                                                }
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                </td>

                                                                                <td className="to-defect-photo" style={{border:"none",paddingRight:"0",borderLeft:"1px solid #f4f4f4"}}>
                                                                                    <div style={{margin:"5px auto"}}><u>Rectifications</u></div>
                                                                                    {
                                                                                        (numRectify > 0)
                                                                                            ?
                                                                                            <div style={{textAlign:(numRectify > 3) ? "left" : "center"}}>
                                                                                            {
                                                                                                item.defects.map(
                                                                                                    (defect,d)=>{
                                                                                                        return defect.resolvePhoto.map(
                                                                                                            (photo,p)=>{
                                                                                                                return (
                                                                                                                    <img src={photo} key={d+"-"+p} className="defect-photo"/>
                                                                                                                )
                                                                                                            }
                                                                                                        )
                                                                                                    }
                                                                                                )
                                                                                            }
                                                                                            </div>
                                                                                            :
                                                                                            <div style={{margin:"10px auto"}}>No Rectifications</div>
                                                                                    }
                                                                                </td>
                                                                            </td>
                                                                        </tr>
                                                                    </tr>
                                                                  )
                                                              }
                                                          )
                                                      }
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                      :
                                      <div className="report-section">
                                          <div className="report-section-title">Handover Defects</div>
                                          <div className="report-section-desc" style={{borderBottom:"1px solid #f4f4f4"}}>
                                              No defects have been found and recorded during the handover process for any of the inventory items listed above
                                          </div>
                                      </div>
                              }

                              {
                                  (content.photoRender.length > 0)
                                      ?
                                      <div className="report-section">
                                          <div className="report-section-title">General Photos</div>
                                          <div className={"report-table" + ((content.photoRender.length < 2) ? " half" : "")}>
                                              <table>
                                                  <tbody>
                                                      {
                                                          content.photoRender.map(
                                                              (row,rowIndex)=>{
                                                                return(
                                                                    <tr key={rowIndex}>
                                                                        {
                                                                            row.map(
                                                                                (item,index)=>{
                                                                                    return(
                                                                                        <td className="report-item" key={index}>
                                                                                            <img src={item} className="report-image"/>
                                                                                        </td>
                                                                                    )
                                                                                }
                                                                            )
                                                                        }
                                                                    </tr>
                                                                )
                                                              }
                                                          )
                                                      }
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                      :
                                      null
                              }

                              <div className="report-section">
                                  <div className="report-section-title">Inventory Damages</div>
                                  <div className="report-table">
                                      <table>
                                          <thead>
                                              <tr>
                                                  <th className='ho-sn'>Damage</th>
                                                  <th className="ho-item"/>
                                                  <th className="ho-quantity">Quantity</th>
                                                  <th className="ho-damages">Subtotal</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              {
                                                  toDamageList.map(
                                                      (item,index)=>{
                                                          const actualQuantity = ((item.quantity) ? parseInt(item.quantity) : 0) - ((item.waive) ? parseInt(item.waive) : 0);
                                                          if(actualQuantity <= 0){
                                                              return null;
                                                          }
                                                          return (
                                                            <tr key={index}>
                                                                <td className="ho-sn" style={{verticalAlign:"top"}}>{index+1}.</td>
                                                                <td className="ho-item" style={{verticalAlign:"top"}}>
                                                                    {item.itemName} - {item.label}<br/>{item.remarks}
                                                                    <div className="damage-photo-container">
                                                                        {
                                                                            item.photo.map(
                                                                                (url,p)=>{
                                                                                    return <img key={p} src={url} className="damage-photo"/>
                                                                                }
                                                                            )
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td className="ho-quantity" style={{verticalAlign:"top"}}>{actualQuantity}</td>
                                                                <td className="ho-damages" style={{verticalAlign:"top"}}>${HOTOItem.calculateDamages(item).toFixed(2)}</td>
                                                            </tr>
                                                          )
                                                      }
                                                  )
                                              }
                                          </tbody>
                                      </table>
                                  </div>
                              </div>

                              <div className="report-section">
                                  <div className="report-section-title">Acknowledgement</div>
                                  <div className="report-section-desc">
                                      The contents of this takeover report and inventory items have been duly verified by the following representatives
                                  </div>
                                  <div className="report-table">
                                      <table>
                                          <tbody>
                                              <tr className="report-row-double">
                                                <td><b>Representative 1</b></td>
                                                <td>
                                                    {
                                                        (content.toPrimaryName)
                                                            ?
                                                            <span><b>{content.toPrimaryType}</b><br/></span>
                                                            :
                                                            null
                                                    }
                                                    {this.setDef(content.toPrimaryName)}
                                                </td>
                                                <td><b>Signature</b></td>
                                                <td style={{textAlign:"cener"}}>
                                                    {
                                                        (content.toPrimarySign)
                                                            ?
                                                            <img src={content.toPrimarySign} className="hoto-report-sign"/>
                                                            :
                                                            "None"
                                                    }
                                                </td>
                                              </tr>

                                              <tr className="report-row-double">
                                                <td><b>Representative 2</b></td>
                                                <td>
                                                    {
                                                        (content.toSecondaryName)
                                                            ?
                                                            <span><b>{content.toSecondaryType}</b><br/></span>
                                                            :
                                                            null
                                                    }
                                                    {this.setDef(content.toSecondaryName)}
                                                </td>
                                                <td><b>Signature</b></td>
                                                <td style={{textAlign:"cener"}}>
                                                    {
                                                        (content.toSecondarySign)
                                                            ?
                                                            <img src={content.toSecondarySign} className="hoto-report-sign"/>
                                                            :
                                                            "None"
                                                    }
                                                </td>
                                              </tr>

                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                        )
                    }
                )
              }
            </div>
        )
    }
}
